import * as React from 'react';

function SvgListIcon(props) {
  return (
    <svg
      width={10}
      height={10}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.75 8.75a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" fill="#0F8CFF" />
      <path
        opacity={0.3}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.667 2.918a2.499 2.499 0 014.666 1.249c0 .925-.503 1.734-1.25 2.166V6.25a3.333 3.333 0 00-3.416-3.332z"
        fill="#0F8CFF"
      />
    </svg>
  );
}

export default SvgListIcon;
